import { Close, MyLocationOutlined } from "@mui/icons-material";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContentText,
  DialogTitle,
  IconButton,
} from "@mui/material";
import FormActionButton from "../buttons/formActionButton.component";
import { useIsMobile } from "../../hook/useIsMobile";

const DevicePositionDialog = ({ handleClose, open, onChoiseSelected }) => {
  const isMobile = useIsMobile();
  const handleChoice = (choise) => {
    onChoiseSelected(choise);

    handleClose();
  };
  return (
    <Dialog
      onClose={handleClose}
      open={open}
      aria-labelledby="device-position-dialog"
      aria-describedby="take device position"
      sx={{
        "& .MuiDialog-paper": {
          width: "auto",
          height: isMobile ? "auto" : "316px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: 2,
        },
      }}
    >
      <Box width="100%" height="100%" display="flex" justifyContent="end">
        <IconButton aria-label="close" onClick={handleClose}>
          <Close
            sx={{ width: "20px", height: "20px", color: "text.primary" }}
          />
        </IconButton>
      </Box>
      <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
        <MyLocationOutlined sx={{ width: "40px", height: "40px" }} />
      </Box>
      <DialogTitle
        sx={{
          fontWeight: "bold",
          fontSize: "20px",
          textAlign: "center",
          width: "100%",
        }}
      >
        Vuoi usare la tua posizione attuale?
      </DialogTitle>
      <DialogContentText
        id="custom-dialog-description"
        sx={{ fontSize: "14px", textAlign: "center", marginX: 2 }}
      >
        Posiziona il sensore nella mappa tramite la posizione gps del tuo
        dispositivo
      </DialogContentText>
      <DialogActions
        sx={{
          justifyContent: "center",
          marginY: 4,
          width: "100%",
        }}
      >
        <>
          <FormActionButton
            onClick={() => handleChoice("device")}
            label="Conferma"
          />
          <FormActionButton
            onClick={() => handleChoice("handPosition")}
            label="Posiziona a mano"
            variant="outlined"
          />
        </>
      </DialogActions>
    </Dialog>
  );
};

export default DevicePositionDialog;
